import PptxGenJS from "pptxgenjs";
import dayjs from "dayjs";
import {
  BACKGROUND_IMAGE_PATH,
  BRAND_LOGO,
  getMediaContent,
  OPACITY_OVERLAY,
  overwriteComponent,
} from "./components";

export const LOGO_CENTER_MASTER = "LOGO_CENTER_MASTER";

export const logoCenterMasterSlide: PptxGenJS.SlideMasterProps = {
  title: LOGO_CENTER_MASTER,
  background: {
    color: "#FFFFFF",
  },
  objects: [
    overwriteComponent(BRAND_LOGO, {
      image: {
        x: 7.27,
        y: 3.56,
        align: "center",
        valign: "middle",
        w: 1.46,
        h: 1.88,
      },
    }),
  ],
};
